import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Message } from "primeng/components/common/api";
import { AuthAccessProvider } from "../core/core.auth";
import { BaseComponent, Client, UserContext, UserInfo } from "../core/core.component";
import { BusyProvider } from "../service/busy.service";
import { MessageProvider } from "../service/message.service";
import { UserService } from "../service/user.service";
import { ClientService } from "app/service/clients.service";

@Component({
	selector: "app-clients",
	templateUrl: "./clients.component.html",
	styleUrls: ["./clients.component.css"],
})
export class ClientsComponent extends BaseComponent implements OnInit {
	clients: Client[]=[];
	userContext: UserContext;
	userInfo: UserInfo = new UserInfo();
	filteredClients: Client[] = [];
	onlyActive: boolean = false;
	loading: boolean = false;
	filterQuery: string = "";
	clientSelected: Client = new Client();
	validationMessage: string = null;
	showDeleteAlert = false;

	sortField = 'cliente';
	sortAsc = true;

	idcliente: number = null;
	cdc: string = null;
	email : string = null;
	dscliente: string = null;
	referente: string = null;

	msgs: Message[] = [];

	constructor(
		protected authAccess: AuthAccessProvider,
		protected router: Router,
		protected messageProvider: MessageProvider,
		private userService: UserService,
		private busyProvider: BusyProvider,
		private clientService: ClientService
	) {
		super(authAccess, router, messageProvider);
		this.messageProvider.clearAll();
	}

	ngOnInit() {
		this.userContext = this.authAccess.getUserContext();
		if (this.userContext == null) {
			this.authAccess.invalidate();
		  } else {
			
			this.loadClients();
		  }

		  this.userService.currentUserInfo(this.userContext.srmToken).subscribe(
			(result) => {
				this.userInfo = result;
			},
			(error) => {
				this.handleError(error);
			}
		);	
	}

	loadClients() {
		this.clients = [];
		this.loading = true;
		this.clientService.getClients(this.userContext.srmToken, this.onlyActive).subscribe(
			(result) => {
				if (result.message) {
					const clients = JSON.parse(result.message);
					
					this.clients = clients;
					this.filterClients();
					this.sort();
					this.loading = false;
        			if (this.clientSelected != null && this.clientSelected.idcliente > 0) {
          				this.selectClient(this.clientSelected);
        			}
        			
			}},
			(error) => {
				this.handleError(error);
				this.loading=false;
			}
		);
	}

	storeClient() {
		this.messageProvider.clearAll();
		this.validationMessage = null;
		if (this.dscliente == null || this.dscliente.trim() == "") {
			this.validationMessage = "Inserire il nome del cliente";
			return;
		}

		
		if (this.cdc == null || this.cdc.trim() == "") {
			this.validationMessage = "Inserire il CDC";
			return;
		}

		if (this.referente == null || this.referente.trim() == "") {
			this.validationMessage = "Inserire il referente";
			return;
		}

		// modifica
		if (this.clientSelected.idcliente > 0) {
			this.busyProvider.showBusyIndicator();
			let client: Client = this.buildClient();
			client.idcliente = this.clientSelected.idcliente;
			this.clientService.updateClient(this.userContext.srmToken, client).subscribe(
				() => {
					this.busyProvider.hideBusyIndicator();
					this.msgs = [];
					this.msgs.push({ severity: "success", summary: "OK", detail: "Modifica eseguita correttamente" });
					this.clientSelected = client;
					this.loadClients();
				},
				(error) => {
					this.busyProvider.hideBusyIndicator();
					this.handleError(error);
				}
			);
		}
		// inserimento
		else {
			this.busyProvider.showBusyIndicator();
			let client: Client = this.buildClient();
			this.clientService.insertClient(this.userContext.srmToken, client).subscribe(
				(result) => {
					this.busyProvider.hideBusyIndicator();
					this.msgs = [];
					this.msgs.push({ severity: "success", summary: "OK", detail: "Utente inserito correttamente" });
					client.idcliente = Number(result.message);
					this.clientSelected = client;
					this.loadClients();

				},
				(error) => {
					this.busyProvider.hideBusyIndicator();
					this.handleError(error);
				}
			);
		}
	}

	buildClient(): Client {
		let client: Client = new Client();
		client.dscliente = this.dscliente;
		client.cdc = this.cdc;
		client.email = this.email;
		client.referente = this.referente;
		return client;
	}

	selectClient(client: Client){
		this.validationMessage = null;
		this.idcliente=client.idcliente;
		this.clientSelected = client;
		this.dscliente = this.clientSelected.dscliente;
		this.cdc = client.cdc;
		this.email=client.email;
		this.referente=client.referente;
	}

	addNewClient() {
		this.validationMessage = null;
		this.messageProvider.clearAll();
		this.clientSelected = new Client();
		this.idcliente=null;
		this.dscliente=null;
		this.cdc=null;
		this.email=null;
		this.referente=null;
	}

	filterClients(){
		this.filteredClients=this.clients;
		if (this.filterQuery != null && this.filterQuery.trim() != "") {
			this.filteredClients = [];
			for (let i = 0; i < this.clients.length; ++i) {
				let dsclient = this.clients[i].dscliente;
				let cdc = this.clients[i].cdc;
				let email = this.clients[i].email;
				let referente = this.clients[i].referente;
				let filterQuery = this.filterQuery;
				if ((dsclient && filterQuery && dsclient.toLowerCase().indexOf(filterQuery.toLowerCase()) >= 0) ||
				(cdc && filterQuery && cdc.toLowerCase().indexOf(filterQuery.toLowerCase()) >= 0) || 
				(email && filterQuery && email.toLowerCase().indexOf(filterQuery.toLowerCase()) >= 0) || 
				(referente && filterQuery && referente.toLowerCase().indexOf(filterQuery.toLowerCase()) >= 0))
				{
					this.filteredClients.push(this.clients[i]);
				}
			}
		}
		if (this.filteredClients.length == 1) {
			this.clientSelected = this.filteredClients[0];
			this.selectClient(this.clientSelected);
		}	
	}

	openDeleteAlert(current: Client) {
		this.selectClient(current);
		this.showDeleteAlert = true;
	  }

	closeDeleteAlert() {
		this.showDeleteAlert = false;
	}
	
	deleteClient() {
		this.messageProvider.clearAll();
		this.validationMessage = null;
	
		this.busyProvider.showBusyIndicator();
		this.clientService.deleteClient(this.userContext.srmToken, this.idcliente).subscribe(
		  result => {
			this.busyProvider.hideBusyIndicator();
			this.msgs = [];
			this.msgs.push({severity: 'success', summary: 'OK', detail: 'Cancellazione eseguita correttamente'});
			this.addNewClient();
			this.loadClients();
		  },
		  error => {
			this.busyProvider.hideBusyIndicator();
			this.handleError(error);
		  });
	}

	sort(field?: string, asc?: boolean) {
		if (field && field === this.sortField && (typeof asc === 'undefined' || asc == !this.sortAsc)) {
			this.filteredClients = this.filteredClients.reverse();
			this.sortAsc = !this.sortAsc;
		} else {
			if (field) {
				this.sortField = field;
				this.sortAsc = true;
			}
			this.filteredClients = this.filteredClients.sort((a1, a2) => {
				var res = 0;
				if (this.sortField === 'cliente') {
					res = this.compareStrings(a1.dscliente, a2.dscliente);
				} else if (this.sortField === 'cdc') {
					res = this.compareStrings(a1.cdc, a2.cdc);
				} else if (this.sortField === 'referente') {
					res = this.compareStrings(a1.referente, a2.referente);
				} else if (this.sortField === 'email') {
					res = this.compareStrings(a1.email, a2.email);
				}
				return this.sortAsc ? res : -res;
			});
		}
	}

	private compareStrings(s1: string, s2: string) {
		return (s1 ? s1.toLowerCase() : '') > (s2 ? s2.toLowerCase() : '') ? 1 : -1;
	}
	
}



// WEBPACK FOOTER //
// ./src/app/clients/clients.component.ts